import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import Button from 'components/Button';
import classnames from 'classnames';

import SignupForm from './components/SignupForm';
import styles from './Signup.module.scss';
import { scrollToElem } from './smooth-scrolling-polyfill';
import { getSignupContent } from './util';
import HeaderLogo from 'components/HeaderLogo';

export const pageId = 'signupPage';
export const formSectionId = 'signupFormSection';

export default function Signup() {
  const [formPositionY, setFormPositionY] = useState(null);
  const [windowHeight, setWindowHeight] = useState(null);
  const [displayPrompt, setDisplayPrompt] = useState(false);

  useEffect(() => {
    const handleResizeAndScroll = throttle(() => {
      setFormPositionY(
        document.getElementById(formSectionId).getBoundingClientRect().top,
      );
      setWindowHeight(window.innerHeight);
    }, 50);
    handleResizeAndScroll();

    window.addEventListener('resize', handleResizeAndScroll);
    window.addEventListener('scroll', handleResizeAndScroll);
    return () => {
      window.removeEventListener('resize', handleResizeAndScroll);
      window.removeEventListener('scroll', handleResizeAndScroll);
    };
  }, []);

  useEffect(() => {
    const pageHeight = document.getElementById(pageId).offsetHeight;
    const reachBottomOfPage = windowHeight + window.pageYOffset >= pageHeight;
    setDisplayPrompt(formPositionY > 1 && !reachBottomOfPage);
  }, [formPositionY, windowHeight]);

  const curTemplate = getSignupContent();
  return (
    <div className={styles.signupPage} id={pageId}>
      <div className={styles.logoWrap}>
        <HeaderLogo />
      </div>
      <div className={classnames(styles.column, styles.introSection)}>
        <div className={styles.content}>
          <div className={styles.greenBar} />
          <h1 className={styles.h1} data-testid="signUpHeader">
            {curTemplate.title}
          </h1>
          <h2 className={styles.h3} data-testid="signUpSubHeader">
            {curTemplate.subtitle}
          </h2>
          <img
            className={styles.image}
            src={curTemplate.heroImg}
            alt="signup intro"
          />
        </div>
      </div>
      <div
        className={classnames(styles.column, styles.formSection)}
        id={formSectionId}
      >
        <SignupForm formHeader={curTemplate.formHeader} />
      </div>
      {displayPrompt && (
        <div className={styles.prompt}>
          <Button
            className={styles.promptButton}
            onClick={() => scrollToElem(`#${formSectionId}`)}
            data-testid="tryItFree_btn"
          >
            Try it free
          </Button>
        </div>
      )}
    </div>
  );
}
